export default {"src":"/_next/static/media/Icon.edb0c8cf.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};